import NHSShiftTracker from './components/NHSShiftTracker';
import './App.css';

function App() {
  return (
    <div className="App">
      <NHSShiftTracker />
    </div>
  );
}

export default App;